import { Box, Typography, Grid, Tooltip } from '@mui/material';
import { TournamentSettingsOption } from 'modules/tournaments/interfaces';
import React, { FC } from 'react';
import { useStyles } from './TournamentSettingsTile.styles';

export const TournamentSettingsTile: FC<TournamentSettingsOption> = ({
  label,
  value,
  needsTooltip = false,
}) => {
  const { classes } = useStyles();

  const description = <Typography className={classes.description}>{value}</Typography>;

  return (
    <Grid item xs={6} md={4}>
      <Box className={classes.root}>
        <Typography component="span" className={classes.header}>
          {label}
        </Typography>
        {value &&
          (needsTooltip ? (
            <Tooltip title={value} enterDelay={1000} enterNextDelay={1000}>
              {description}
            </Tooltip>
          ) : (
            description
          ))}
      </Box>
    </Grid>
  );
};
